import { Component, Input } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-public-private-key',
  templateUrl: './userapi-public-private-key.component.html'
})
export class UserApiPublicPrivateKeyComponent extends AbstractUserApiModalComponent {
  @Input() userApi: UserAPI;
}
